export default {
  'ctxt.respti': {
    ko: 'Response Time',
    ja: '応答時間',
    en: 'Response Time',
    cn: '',
  },
  'ctxt.ttl.kpi': {
    ko: 'KPI Charts',
    ja: 'KPIチャート',
    en: 'KPI Charts',
    cn: '',
  },
  'ctxt.menu.title': {
    ko: 'Context Analyzer',
    ja: 'コンテキストアナライザ',
    en: 'Context Analyzer',
    cn: '',
  },
  'ctxt.ttl.dump.log': {
    ko: 'ABAP Dump & Sys./App. Log',
    ja: 'ABAPダンプ&システム/アプリログ',
    en: 'ABAP Dump & Sys./App. Log',
    cn: '',
  },
  'ctxt.tasktype': {
    ko: 'Task Type',
    ja: 'タスクタイプ',
    en: 'Task Type',
    cn: '',
  },
  'ctxt.msg.java.stack.not.support': {
    ko: 'Context Analyzer는 Java stack을 지원하지 않습니다.',
    ja: 'コンテキストアナライザーは、Javaスタックをサポートしません。',
    en: 'Context Analyzer does not support Java stack.',
    cn: '',
  },
  'ctxt.active.wp.only': {
    ko: 'Active Workprocess Only',
    ja: 'アクティブワークプロセスのみ',
    en: 'Active Workprocess Only',
    cn: '',
  },
  'ctxt.priv.sum': {
    ko: 'Private Memory',
    ja: 'プライベートメモリ',
    en: 'Private Memory',
    cn: '',
  },
  'ctxt.uname': {
    ko: 'Account',
    ja: 'アカウント',
    en: 'Account',
    cn: '',
  },
  'ctxt.ttl.wp.ssr': {
    ko: 'Work Processes & Actions',
    ja: 'ワークプロセス及びアクション',
    en: 'Work Processes & Actions',
    cn: '',
  },
  'ctxt.wp.waiting': {
    ko: '대기중인 이유',
    ja: '待機中の理由',
    en: 'Reason of Waiting',
    cn: '',
  },
  'ctxt.extended.memory': {
    ko: 'Ext. Memory',
    ja: '拡張メモリ',
    en: 'Ext. Memory',
    cn: '',
  },
  'ctxt.mem.total': {
    ko: 'Total Memory',
    ja: '総メモリ',
    en: 'Total Memory',
    cn: '',
  },
  'ctxt.ttl.owl.alert': {
    ko: 'OWLens Alerts',
    ja: 'OWLensアラート',
    en: 'OWLens Alerts',
    cn: '',
  },
  'ctxt.wp.status': {
    ko: 'Status',
    ja: '状況',
    en: 'Status',
    cn: '',
  },
  'ctxt.dbtime': {
    ko: 'DB Time',
    ja: 'DB時間',
    en: 'DB Time',
    cn: '',
  },
};
